import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { filter, Subscription } from 'rxjs';
import { hospitalAvailabilityFormConfig } from '../../config/hospital-availability-form.config';
import { HospitalAvailabilityService } from '../../../../services/hospitalAvailability/hospitalAvailability.service';
import { CoreService } from '../../../core/core.service';
import { HospitalAvailability } from '../../../core/models/hospital-availability.model';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-hospital-availability-form-dialog',
  templateUrl: './hospital-availability-form-dialog.component.html',
  styleUrl: './hospital-availability-form-dialog.component.scss',
})
export class HospitalAvailabilityFormDialogComponent {
  subscriptions: Subscription[] = [];
  @ViewChild('eoForm', { static: false }) eoForm?: EoFormComponent;

  hospitalAvailability?: HospitalAvailability;

  token$ = this.authService.token$;
  tokenData = this.token$.getValue();

  visible = false;
  formConfig = [...hospitalAvailabilityFormConfig];

  @Output() success = new EventEmitter();

  constructor(
    private hospitalAvailabilityService: HospitalAvailabilityService,
    private coreService: CoreService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.subscriptions = [
      this.getHospitalAvailabilitySaveSuccessSub$(),
      this.getHospitalAvailabilityUpdateSuccessSub$(),
    ];
  }

  isClinicDropdownVisible(): boolean {
    return this.authService.hasRoles(['PrivateHospitalAdmin']);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.hospitalAvailability) return;

    let hospitalAvailabilityToStore = {
      id: this.hospitalAvailability?.id ?? null,
      hospitalID: this.tokenData?.hospitalId ?? '',
      clinicID: this.tokenData?.clinicId ?? $event.hospitalAvailability?.clinicID ?? null, 
      availabilityMonth: $event.hospitalAvailability.availabilityMonth,
      availabilityYear: $event.hospitalAvailability.availabilityYear,
      slots: $event.hospitalAvailability.slots,
    };

    hospitalAvailabilityToStore.id
      ? this.hospitalAvailabilityService
          .updateHospitalAvailability(
            hospitalAvailabilityToStore as HospitalAvailability
          )
          .subscribe()
      : this.hospitalAvailabilityService
          .saveHospitalAvailability(hospitalAvailabilityToStore)
          .subscribe();
  }

  onSubmitSuccess(): void {
    this.hospitalAvailabilityService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess('Η διαθεσιμότητα αποθηκεύτηκε με επιτυχία');
  }

  setFcValue(formControlName: string, value: any) {
    return this.eoForm?.setValue(
      'hospitalAvailability',
      formControlName,
      value
    );
  }

  getFormConfig() {
    return this.formConfig;
  }

  getHeader(): string {
    return this.hospitalAvailability?.id
      ? `Επεξεργασία Διαθεσιμότητας`
      : 'Νέα Διαθεσιμότητα';
  }

  initForm() {
    this.eoForm?.form.reset();
    this.eoForm?.form.enable();

    if (this.hospitalAvailability) {
      this.setFcValue(
        'availabilityMonth',
        this.hospitalAvailability.availabilityMonth
      );
      this.setFcValue(
        'availabilityYear',
        this.hospitalAvailability.availabilityYear
      );
      this.setFcValue('slots', this.hospitalAvailability.slots);
      this.setFcValue('clinicID', this.hospitalAvailability.clinicID);
    }
  }

  getHospitalAvailabilitySaveSuccessSub$() {
    return this.hospitalAvailabilityService.hospitalAvailabilitySaveCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  getHospitalAvailabilityUpdateSuccessSub$() {
    return this.hospitalAvailabilityService.hospitalAvailabilityUpdateCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  isSubmitLoading(): boolean {
    let cSaveStatus =
      this.hospitalAvailabilityService.hospitalAvailabilitySaveCallHandler?.status$?.getValue();
    if (cSaveStatus === STATUS.loading) return true;

    let cUpdStatus =
      this.hospitalAvailabilityService.hospitalAvailabilityUpdateCallHandler?.status$?.getValue();
    if (cUpdStatus === STATUS.loading) return true;

    return false;
  }

  show(hospitalAvailability?: HospitalAvailability): void {
    this.hospitalAvailability = hospitalAvailability;
    this.initForm();
    this.visible = true;
  }
}
